// extracted by mini-css-extract-plugin
export default {"recos":"t5-z","productCardOverride":"u5-z","rowHasBadge":"v5-z"};